// Config
import { getStorageItem } from '@utils/storage/storage';

export function dispatchMonetateEvent({
  eventName,
  trackData = true,
}: { eventName?: string; trackData?: boolean } = {}) {
  if (!eventName) return;

  try {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['trackEvent', [eventName]]);

    if (trackData) {
      window.monetateQ.push(['trackData']);
    }

    if (getStorageItem('logAnalytics', true) === 'true') {
      /* eslint-disable no-console */
      console.warn('---------- DISPATCH MONETATE EVENT ----------');
      console.warn(`-- event: ${eventName} --`);
      /* eslint-enable no-console */
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to dispatch Monetate event:', err);
  }
}
